import { Link } from 'react-router-dom';
import { NavigateRoutesEnum } from '@routing/routesEnum';
import MainPhoto from '@pages/home/dogs/MainPhoto';
import VideoBox from '@pages/home/dogs/VideoBox';
import AdvantagesBox from '@pages/home/dogs/AdvantagesBox';
import VeterinaryBox from '@pages/home/dogs/VeterinaryBox';
import SocialMedia from '@components/social-media/SocialMedia';



const Dogs = (): JSX.Element => {

	return (
		<div className='home-content dogs-page'>
			
			<MainPhoto />

			<div className='info-box'>
				<h1>POOPERAČNÍ LÍMEC PRO&nbsp;PSA</h1>
				<p>VETlímce pro&nbsp;psy jsme vyvinuli ve&nbsp;spolupráci s&nbsp;veterinárními lékaři tak, aby psům přinášely maximální komfort a&nbsp;bezpečí. Představují nový standard pooperační péče a&nbsp;léčby či&nbsp;prevence v&nbsp;případě chronických potíží. Naše zdravotní límce jsou vyráběny na&nbsp;míru, s&nbsp;ohledem na&nbsp;individuální potřeby různých plemen psů, s&nbsp;přihlédnutím k&nbsp;povaze a&nbsp;tělesné konstituci každého psího pacienta. Věříme, že&nbsp;i&nbsp;Váš pes si&nbsp;zaslouží víc!</p>
			</div>

			<VideoBox />

			<AdvantagesBox />

			<VeterinaryBox />

			<div className='order-button-box'>
				<Link to={NavigateRoutesEnum.order} className='app-main-button disable-selection'>
					CHCI&nbsp;OBJEDNAT
				</Link>
			</div>

			<SocialMedia />

		</div>
	);
};

export default Dogs;